import { render } from "./FormGNC.vue?vue&type=template&id=ba9e7e60"
import script from "./FormGNC.vue?vue&type=script&lang=js"
export * from "./FormGNC.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__